<template>
  <div class="content work_flow_wrap" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="tab-wrap">
      <el-tabs v-model="page.listType" @tab-click="onTabClick">
        <el-tab-pane label="全部流程" name="0"> </el-tab-pane>
        <el-tab-pane label="待处理" name="4"></el-tab-pane>
        <el-tab-pane label="我审批的" name="2"></el-tab-pane>
        <el-tab-pane label="我收到的" name="3"></el-tab-pane>
        <el-tab-pane label="我发起的" name="1"></el-tab-pane>
      </el-tabs>
    </div>
    <!-- 查询 -->
    <div class="search-area pt0">
      <el-row :gutter="24">
        <el-col :span="6"
          ><div class="search-area-div">公司名称：</div>
          <el-select filterable clearable v-model="page.tenantGuid" class="ipt-sty" placeholder="请选择">
            <el-option
              v-for="item in tenantList"
              :key="item.sendTenantGuid"
              :label="item.sendTenantName"
              :value="item.sendTenantGuid"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="6"
          ><div class="search-area-div">年度：</div>
          <el-date-picker v-model="page.planYear" class="ipt-sty" value-format="yyyy" type="year" placeholder="请选择">
          </el-date-picker>
        </el-col>
        <el-col :span="6"
          ><div class="search-area-div">审批状态：</div>
          <el-select filterable clearable v-model="page.approveState" class="ipt-sty" placeholder="请选择">
            <el-option v-for="item in approveStateOption" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6"
          >
          <el-button size="mini" type="text" @click="showMore = !showMore" :icon="showMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'">
            {{ showMore ? '收起筛选' : '更多筛选' }}
          </el-button>
          <el-button size="mini" type="info" @click="getList(1)">搜索</el-button>
          <el-button size="mini" type="danger" @click="emptySearch">清空</el-button></el-col
        >
      </el-row>
      <el-row :gutter="24" class="mt15" v-show="showMore">
        <el-col :span="6"
          ><div class="search-area-div">下发状态：</div>
          <el-select filterable clearable v-model="page.downState" class="ipt-sty" placeholder="请选择">
            <el-option v-for="item in downStateOption" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
    </div>
    <!-- 内容 -->
    <div class="back-color-fff content-main-box"  style="height: 100%">
      <div class="button-area">
        <el-button icon="el-icon-plus" size="mini" type="info" @click="addMarketing">制定终端服务计划</el-button>
      </div>
      <el-table :data="tableData" stripe border style="width: 100%" v-loading="tableLoading" :height="tableHeight">
        <el-table-column label="序号" width="60" header-align="center" align="center" fixed="left">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column
          prop="tenantName"
          label="公司名称"
          show-overflow-tooltip
          header-align="center"
          align="left"
          min-width="200"
          fixed="left"
        >
          <template slot-scope="scope">{{ scope.row.tenantName || '-' }}</template>
        </el-table-column>
        <el-table-column
          prop="planName"
          label="终端服务计划名称"
          show-overflow-tooltip
          header-align="center"
          align="left"
          min-width="200"
        >
          <template slot-scope="scope">{{ scope.row.planName || '-' }}</template>
        </el-table-column>
        <el-table-column
          prop="planYear"
          label="年度"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="80"
        >
          <template slot-scope="scope">{{ scope.row.planYear || '-' }}</template>
        </el-table-column>
        <el-table-column prop="budgetTotal" width="120" label="合计金额(元)" header-align="center" align="right">
          <template slot-scope="scope">{{ scope.row.budgetTotal | numDigit }}</template>
        </el-table-column>
        <!-- <el-table-column
          prop="createTime"
          label="首次提交时间"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="100"
        >
          <template slot-scope="scope">{{ scope.row.createTime | getDate }}</template>
        </el-table-column> -->
        <el-table-column prop="endTime" label="审批状态" header-align="center" align="center" width="100">
          <template slot-scope="scope"
            ><span :class="getStateShow(scope.row.approveVO.approveState)">{{
              scope.row.approveVO.approveState | approveState
            }}</span></template
          >
        </el-table-column>
        <el-table-column prop="staffName" label="提交人" header-align="center" align="left" width="120">
          <template slot-scope="scope">{{ scope.row.createUserName }}</template>
        </el-table-column>

        <!-- <el-table-column prop="startTime" label="操作时间" header-align="center" align="left" width="140">
          <template slot-scope="scope">{{ scope.row.updateTime | getTime }}</template>
        </el-table-column> -->
        <el-table-column prop="downState" label="下发状态" header-align="center" align="center" width="100">
          <template slot-scope="scope">{{ scope.row.downState | downState }}</template>
        </el-table-column>
        <el-table-column prop="bank" width="200" label="操作" fixed="right" header-align="center" align="center">
          <template slot-scope="scope">
            <a
              class="txt-color"
              v-if="getListBtnState('detail', scope.row) == 'detail'"
              @click="editMarketing(scope.row, 2)"
            >
              详情
            </a>
            <a
              class="txt-color"
              @click="
                passDialogVisible = true;
                approveSuggest = '';
                form = scope.row;
              "
              v-if="getListBtnState('approval', scope.row) == 'approval'"
            >
              通过
            </a>
            <a
              class="txt-color"
              @click="
                rejectDialogVisible = true;
                approveSuggest = '';
                form = scope.row;
              "
              v-if="getListBtnState('approval', scope.row) == 'approval'"
            >
              驳回
            </a>
            <a class="txt-color" @click="toRevoke(scope.row)" v-if="getListBtnState('revoke', scope.row) == 'revoke'">
              撤销
            </a>
            <a
              class="txt-color"
              @click="editMarketing(scope.row, 1)"
              v-if="getListBtnState('edit', scope.row) == 'edit'"
            >
              编辑
            </a>
            <a
              class="txt-color"
              v-if="getListBtnState('del', scope.row) == 'del'"
              @click="delMarketing(scope.row.guid)"
            >
              删除
            </a>

            <a
              class="txt-color"
              v-if="getListBtnState('again', scope.row) == 'again'"
              @click="editMarketing(scope.row, 3)"
            >
              重新提交
            </a>
            <a
              class="txt-color"
              v-if="isShowDownBtn(scope.row)"
              @click="getDownState(scope.row)"
            >
              下发
            </a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pt pb back-color-fff"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 20, 50, 100]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>
    <el-dialog title="驳回流程" :visible.sync="rejectDialogVisible" width="30%" top="15%">
      <el-input type="textarea" :rows="5" placeholder="输入驳回理由（必填）" v-model="approveSuggest" maxlength="100">
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f" @click="toRejectSubmit()">驳回</el-button>
      </span>
    </el-dialog>
    <el-dialog title="填写通过备注" :visible.sync="passDialogVisible" width="30%" top="15%">
      <el-input type="textarea" :rows="5" placeholder="请填写通过备注（选填）" v-model="approveSuggest" maxlength="100">
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f" @click="toPassSubmit()">通过</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { route } from '@/api/apiRoute';
import store from '@/store';
import workFlowCommon from '@/uilt/workFlowCommon';
export default {
  data() {
    return {
      tableHeight: window.innerHeight - 305,
      showMore: false, // 筛选项显示更多，默认否，最多显示三个
      flowType: '00014',
      fullscreenLoading: false,
      currentStaffGuid: null,
      tenantList: [], //公司名称
      page: {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: null,
        planYear: null,
        approveState: '',
        downState: '',
        currentTenantGuid: '',
        listType: '0',
      },
      tableLoading: false,
      tableData: [],
      height: window.innerHeight - 400,
      right: 'right',
      approveSuggest: '',
      passDialogVisible: false,
      rejectDialogVisible: false,
      form: '',
      approveStateOption: [
        { label: '全部', value: '' },
        { label: '草稿中', value: 'N' },
        { label: '审批中', value: 'A' },
        { label: '已通过', value: 'Y' },
        { label: '已驳回', value: 'R' },
        { label: '已撤销', value: 'C' },
      ],
      downStateOption: [
        { label: '全部', value: '' },
        { label: '已下发', value: 'Y' },
        { label: '未下发', value: 'N' },
        { label: '部分下发', value: 'P' },
      ],
    };
  },
  showMore(val, oldVal) {
    if(val) {
      this.tableHeight = window.innerHeight - 355;
      return;
    }
    if(!val) {
      this.tableHeight = window.innerHeight - 305;
      return;
    }
  },
  created() {
    let userinfo = JSON.parse(localStorage.userInfo);
    this.currentStaffGuid = userinfo.staffGuid;
    this.getList();
    this.getTenantList();
  },
  watch: {},
  methods: {
    onTabClick() {
      // if (this.page.listType == 3) {
      //   this.page.approveState = 'Y'
      // }else if (this.page.listType == 4) {
      //   this.page.approveState = 'A'
      // } else {
      //   this.page.approveState = null;
      // }
      this.getList();
    },
    //获取操作按钮显隐
    getListBtnState(btnType, row) {
      let approveVO = row.approveVO;
      return workFlowCommon.getListBtnState(
        btnType,
        approveVO.approveState,
        approveVO.staffGuid,
        approveVO.approveStaffGuids,
        this.currentStaffGuid,
        row.bizApproveState,
      );
    },
    isShowDownBtn(row){
      let approveVO = row.approveVO;
      let staffGuid=approveVO.staffGuid
      if((row.downState=='N'||row.downState=='P')&&approveVO&&approveVO.approveState == 'Y' && this.currentStaffGuid == staffGuid){
        return true
      }
      return false
    },
    //下发
    getDownState(row) {
      let self = this;
      self
        .$confirm('确定下发吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          self.fullscreenLoading = true;
          let marketingPlanDetailGuid = '';
          let marketingPlanGuid = row.guid;
          self.api
            .postJson(
              `/${serverConfig.msSalesPerformService}/marketing-plan/down-plan?marketingPlanDetailGuid=${marketingPlanDetailGuid}&marketingPlanGuid=${marketingPlanGuid}`,
            )
            .then((res) => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.fullscreenLoading = false;
                self.$message.success('下发成功！');
                self.getList(1);
              } else {
                self.fullscreenLoading = false;
                self.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => {
          self.$message({
            type: 'info',
            message: '已取消操作！',
          });
        });
    },
    //获取审批状态
    getStateShow(approvalState) {
      return workFlowCommon.getStateClass(approvalState);
    },
    //新增
    addMarketing() {
      this.$router.push({
        path: '/marketingPlanAdd',
        query: {
          productGuid: this.$route.query.productGuid
        }
      });
    },
    //获取公司
    getTenantList() {
      let self = this;
      // let query = {
      //   isService: true,
      //   tenantGuid: localStorage.guid,
      // };
      let query ={
        'pageIndex':1,
        'pageSize':-1,
        'bizState':'Y',
        'enterpriseCates':this.$getValueListByKey('上游客户分类')
      }
      self.api
        .postJson(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation`,query)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.tenantList = res.data.data.records;
            if (self.$route.query.guid) {
            self.getPageDetail();
          }
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    //清空
    emptySearch() {
      this.page = {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: null,
        planYear: null,
        approveState: '',
        downState: '',
        listType: '0',
      };
      this.getList(1);
    },
    //type 为1编辑 3重新提交 2为详情
    editMarketing(row, type) {
      let approveVO = row.approveVO;
      let query = {
        guid: row.guid,
        approveStaffGuid: approveVO.approveGuid,
        camundaInstanceId: approveVO.camundaInstanceId,
        camundaDeploymentId: approveVO.camundaDeploymentId,
        tenantGuid: row.tenantGuid,
        submitStaffGuid: approveVO.staffGuid,
        submitStaffName: approveVO.staffName,
        productGuid: this.$route.query.productGuid
      };
      this.$router.push({
        path: type == 1 || type == 3 ? '/marketingPlanAdd' : '/marketingPlanDetail',
        query,
      });
    },
    getList(type) {
      let self = this;
      if (type == 1) {
        self.page.pageIndex = 1;
      }
      self.tableLoading = true;
      self.page.currentTenantGuid = localStorage.guid;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/marketing-plan/list`, this.page).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records || [];
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    // 删除
    delMarketing(guid) {
      let self = this;
      self
        .$confirm(messageConfig.DELETE_AFTER, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          self.api.postJson(`/${serverConfig.msSalesPerformService}/marketing-plan/delete`, [guid]).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.$message.success(messageConfig.DELETE_SUCCESS);
              self.page.pageIndex = 1;
              self.getList();
            } else {
              self.$message.error(res.data.msg);
            }
          });
        });
    },
    //驳回提交
    toRejectSubmit() {
      let userinfo = JSON.parse(localStorage.userInfo);
      if (this.approveSuggest == '') {
        this.$message.error('请填写驳回理由！');
        return;
      }
      let query = {
        guid: this.form.approveVO.approveGuid,
        flowType: this.flowType,
        approveSuggest: this.approveSuggest,
        approveStaffGuid: userinfo.staffGuid,
      };
      this.fullscreenLoading = true;

      this.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/backup-flow`, query).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.rejectDialogVisible = false;
          this.$message.success(messageConfig.FLOW_REJECT);
          this.getList();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    //通过
    toPassSubmit() {
      let userinfo = JSON.parse(localStorage.userInfo);
      let query = {
        guid: this.form.approveVO.approveGuid,
        flowType: this.flowType,
        approveSuggest: this.approveSuggest,
        approveStaffGuid: userinfo.staffGuid,
      };
      this.fullscreenLoading = true;
      this.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/allow-flow`, query).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.passDialogVisible = false;
          this.$message.success(messageConfig.FLOW_PASS);
          this.getList();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    //撤销
    toRevoke(form) {
      let self = this;
      this.$confirm(messageConfig.FLOW_IS_CANCEL, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          let query = {
            guid: form.approveVO.approveGuid,
            flowType: this.flowType,
            approveStaffGuid: form.approveVO.staffGuid,
          };
          self.fullscreenLoading = true;
          self.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/canal-flow`, query).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.fullscreenLoading = false;
              self.$message.success(messageConfig.FLOW_CANCEL);
              self.getList();
            } else {
              self.$message.error(res.data.msg);
            }
          });
        })
        .catch(() => {
          self.$message({
            type: 'info',
            message: '已取消操作！',
          });
        });
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getList();
    },
  },
};
</script>
<style scoped>
.el-table /deep/ .el-input__inner {
  height: 40px;
  line-height: 40px;
}
/deep/ .el-checkbox__label {
  display: none;
}
.attach-sty {
  width: 170px;
  float: left;
  margin-top: 15px;
  text-align: center;
}
.checkbox-img-sty {
  border: 1px solid #dcdfe6;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}
/deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}
/deep/ .el-step__icon-inner {
  color: #4fa1a4;
}
/deep/ .el-step__title.is-process {
  color: #4fa1a4;
}
.el-col-6 {
  display: flex;
  margin-bottom: 10px;
}
.ipt-sty {
  flex: 1;
}
/deep/ .el-input__prefix {
  top: -4px !important;
}
a.txt-color + a.txt-color::before {
  content: '|';
  display: inline-block;
}
.tab-wrap {
  background: #fff;
  padding-left:10px
}
</style>
